import { Stack, CircularProgress } from "@mui/material";

const Loading = ({ isGeneric = false }) => {
  return (
    <Stack
      direction="row"
      sx={{ justifyContent: "center", alignItems: "center", gap: 2 }}
    >
      <CircularProgress size={24} />
      {isGeneric ? "Loading..." : "Checking for available slots..."}
    </Stack>
  );
};

export default Loading;
